import type { oz } from '@weft/utils';
import { FilterInputSchema } from './filter-input-schema';
import { NewMeterSchema } from './new-meter-schema';

export const MeterInputSchema = NewMeterSchema.extend({
  filter: FilterInputSchema.optional(),
});

export type MeterInput = oz.infer<typeof MeterInputSchema>;